//
import { ModuleLayout } from '@/components/reusable_components/next'
import { OfferCreate, OffersList, OfferUpdate } from '@/views/offers'
import GroupedOfferList from '../../views/Offer/GroupedOfferList'
import MassiveOfferCreate from '../../views/Offer/massive/MassiveOfferCreate'
import SlGroupedOfferCreate from '@/views/Sale/SlGroupedOffer/SlGroupedOfferCreate'
import SlGroupedOfferUpdate from '@/views/Sale/SlGroupedOffer/SlGroupedOfferUpdate'

//
export default {
    path: 'offer',
    component: ModuleLayout,
    meta: {
        title: 'Ofertas',
    },
    children: [
        {
            path: '',
            name: 'sl-grouped-offer-list',
            component: GroupedOfferList,
            //component: OffersList,
            meta: {
                remove: true,
            },
        },
        {
            path: 'create',
            name: 'offers_create',
            component: SlGroupedOfferCreate,
            //component: OfferCreate,
            meta: {
                title: 'Crear oferta',
            },
        },
        {
            path: ':id',
            name: 'offers_update',
            // component: OfferUpdate,
            // component: MassiveOfferCreate,
            component: SlGroupedOfferUpdate,
            meta: {
                title: 'Datos de la oferta',
            },
        },
    ],
}
